module.exports = __webpack_public_path__ + "static/media/holland.06532082.png";